import {Outlet, Route, Routes} from "react-router-dom";
import Footer from "./layouts/Footer";
import Header from "./layouts/Header";
import './App.css';
import React, {createContext, useEffect, useState} from "react";
import Promo from "./pages/Promo";
import Features from "./pages/FeaturesRematered";
import useQueryParam from "./hooks/useQueryParam";
import {is_referral_key_exist} from "./misc";
import axios from "axios";
import {useCookieContext} from "./CookieContext";
import SiteDataProvider from "./components/SiteDataProvider";
import Download from "./pages/Download";
import PrivacyPolicy from "./pages/Policy/PrivacyPolicy";
import Streamers from "./pages/Streamers";
import ServerRules from "./pages/Policy/ServerRules";
import TermsAndConditions from "./pages/Policy/TermsAndConditions";
import CookiePolicy from "./pages/Policy/CookiePolicy";
import RefundPolicy from "./pages/Policy/RefundPolicy";
import Redirect from "./components/Header/Redirect";

export const isMobile = window.innerWidth < 769
export const ACTIVE_SERVER = 'remastered-x3'
export const CHRONICLE_LIST = ['remastered', 'hivefive']

export const DEFAULT_SERVER = 'remastered-x3'
export const HOME_PAGE = `/${DEFAULT_SERVER}/features`

export const REMASTERED_OBT_DATE_X3 = new Date(Date.UTC(2024, 4, 17, 17)) /// x3 OBT Remastered

export let LINKS
if (window.location.href.split('/')[2] === 'dares.club') {
    LINKS = {
        mainUrl: 'https://dares.club',
        filesUrl: 'https://nestatic.dares.club',
        cookieDomain: 'dares.club',
        apiUrl: 'https://api.dares.club',
        discord: 'https://discord.gg/dares-club',
        signup: 'https://cabinet.dares.club/signup',
        login: 'https://cabinet.dares.club/login',
        donate: 'https://cabinet.dares.club/donate',
        download: {
            classic: {
                googleDrive: 'https://drive.google.com/file/d/1oGORccgUju5JJZZl9u4tkRmvqL5rnEpz/view?usp=sharing',
                autoUpdater: 'https://updater.dares.club/dares.club.exe',
            }, interlude: {
                googleDrive: 'https://drive.google.com/file/d/1mzN7SslVs0rnUNHselltrzqPGaCU2Rzl/view?usp=sharing',
                clientMega: 'https://mega.nz/file/JllgkSSJ#jkoJnnOebFxTdzhlNgOanWWpqrZkHYMby0Rz7v5M2s4',
                autoUpdater: 'https://updater.dares.club/interlude/dares.club.exe',
                client: 'https://updater.dares.club/interlude/dares.club.zip',
            }, remastered: {
                autoUpdater: 'https://new.dares.club/dares.club.exe',
                client: 'https://new.dares.club/dares.club.zip',
                googleDrive: 'https://drive.google.com/file/d/1bunxshJey8Btytx2xFx-2ubb-3YQfiNk/view?usp=sharing',
                MEGA: 'https://mega.nz/file/JllgkSSJ#jkoJnnOebFxTdzhlNgOanWWpqrZkHYMby0Rz7v5M2s4'
            },
        }
    }
} else if (window.location.href.split('/')[2] === 'localhost:3000') {
    LINKS = {
        mainUrl: `${window.location.href.split('/')[0]}//${window.location.href.split('/')[2]}`,
        cookieDomain: `${window.location.href.split('/')[2]}`,
        filesUrl: 'http://localhost:3001',
        apiUrl: 'https://api.dev.dares.club',
        discord: 'https://discord.gg/dares-club',
        signup: 'https://cabinet.dev.dares.club/signup',
        login: 'https://cabinet.dev.dares.club/login',
        donate: 'https://cabinet.dev.dares.club/donate',
        download: {
            classic: {
                googleDrive: 'https://drive.google.com/file/d/1oGORccgUju5JJZZl9u4tkRmvqL5rnEpz/view?usp=sharing',
                autoUpdater: 'https://updater.dares.club/dares.club.exe',
            }, interlude: {
                googleDrive: 'https://drive.google.com/file/d/1mzN7SslVs0rnUNHselltrzqPGaCU2Rzl/view?usp=sharing',
                clientMega: 'https://mega.nz/file/JllgkSSJ#jkoJnnOebFxTdzhlNgOanWWpqrZkHYMby0Rz7v5M2s4',
                autoUpdater: 'https://updater.dares.club/interlude/dares.club.exe',
                client: 'https://updater.dares.club/interlude/dares.club.zip',
            }, remastered: {
                autoUpdater: 'https://updater.dares.club/dares.club.exe',
                client: 'https://updater.dares.club/dares.club.zip',
                googleDrive: 'https://drive.google.com/file/d/1bunxshJey8Btytx2xFx-2ubb-3YQfiNk/view?usp=sharing',
                MEGA: 'https://mega.nz/file/JllgkSSJ#jkoJnnOebFxTdzhlNgOanWWpqrZkHYMby0Rz7v5M2s4'
            },
        }
    }
} else {
    LINKS = {
        mainUrl: `${window.location.href.split('/')[0]}//${window.location.href.split('/')[2]}`,
        cookieDomain: `${window.location.href.split('/')[2]}`,
        filesUrl: 'https://dev-static.dares.club',
        apiUrl: 'https://api.dev.dares.club',
        discord: 'https://discord.gg/dares-club',
        signup: 'https://cabinet.dev.dares.club/signup',
        login: 'https://cabinet.dev.dares.club/login',
        donate: 'https://cabinet.dev.dares.club/donate',
        download: {
            classic: {
                googleDrive: 'https://drive.google.com/file/d/1oGORccgUju5JJZZl9u4tkRmvqL5rnEpz/view?usp=sharing',
                autoUpdater: 'https://updater.dares.club/dares.club.exe',
            }, interlude: {
                googleDrive: 'https://drive.google.com/file/d/1mzN7SslVs0rnUNHselltrzqPGaCU2Rzl/view?usp=sharing',
                clientMega: 'https://mega.nz/file/JllgkSSJ#jkoJnnOebFxTdzhlNgOanWWpqrZkHYMby0Rz7v5M2s4',
                autoUpdater: 'https://updater.dares.club/interlude/dares.club.exe',
                client: 'https://updater.dares.club/interlude/dares.club.zip',
            }, remastered: {
                autoUpdater: 'https://updater.dares.club/dares.club.exe',
                client: 'https://updater.dares.club/dares.club.zip',
                googleDrive: 'https://drive.google.com/file/d/1bunxshJey8Btytx2xFx-2ubb-3YQfiNk/view?usp=sharing',
                MEGA: 'https://mega.nz/file/JllgkSSJ#jkoJnnOebFxTdzhlNgOanWWpqrZkHYMby0Rz7v5M2s4'
            },
        }
    }
}


export const HeaderToggleContext = createContext()


function MainLayout() {
    return (
        <>
            <Header/>
            <Outlet/>
            <Footer/>
        </>
    );
}

export default function App() {
    const [changeToggle, setChangeToggle] = useState(false);
    const {updateRefKey} = useCookieContext();
    const utm_source = useQueryParam('utm_source');

    useEffect(() => {
        if (!localStorage.getItem('lang')) {
            localStorage.setItem('lang', '"en"')
        }
    }, []);

    useEffect(() => {
        if (utm_source !== null) {
            if (is_referral_key_exist()) {
                return
            }
            let referralKey = utm_source.toLowerCase()
            updateRefKey(referralKey);
            axios.post(`${LINKS.apiUrl}/referral/promo`, {referralKey}).then(() => console.log('success'))
        }
    }, [updateRefKey, utm_source])

    return (
        <HeaderToggleContext.Provider value={{changeToggle, setChangeToggle}}>
            <Routes>
                <Route path="/promo/:referralKey" element={<Promo/>}/>

                <Route path="/:server" element={<SiteDataProvider/>}>
                    <Route element={<MainLayout/>}>
                        <Route path="streamers" element={<Streamers/>}/>
                        <Route path="features" element={<Features/>}/>
                        <Route path="download" element={<Download/>}/>
                        <Route path="privacy-policy" element={<PrivacyPolicy/>}/>
                        <Route path="server-rules" element={<ServerRules/>}/>
                        <Route path="terms" element={<TermsAndConditions/>}/>
                        <Route path="cookie-policy" element={<CookiePolicy/>}/>
                        <Route path="refund-policy" element={<RefundPolicy/>}/>
                    </Route>
                </Route>

                <Route path="/*" element={<Redirect to={HOME_PAGE}/>}/>
            </Routes>
        </HeaderToggleContext.Provider>
    );
}
